import React, { Component } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import overlayFactory from "react-bootstrap-table2-overlay";

import queryString from "app/services/queryStringService";
import _ from "lodash";
import { AiFillFileExcel } from "react-icons/ai";

import { Helmet } from "react-helmet";

import { Accordion, Button, Card } from "react-bootstrap";

import {
  getAllCreditReports,
  exportCreditReports,
} from "app/services/paymentService";
import moment from "moment";

import EditReq from "./EditReq";
import dateTimeFormat from "config.json";
import queryStringService from "app/services/queryStringService";

class CreditOpeningClosing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      data: [],
      sizePerPage: 10,
      dataCount: 0,
      loading: true,
      memId: 0,
      FromDate: "",
      ToDate: "",
      Status: "",
      ReqId: 0,
      showEditReq: false,
    };
  }

  transactionAmountFormatter = (cell, row) => {
    return <span> ₹ {row.amount} </span>;
  };
  transactionModeFormatter = (cell, row) => {
    return <span>{row.transferMethod?.toUpperCase()} </span>;
  };
  dateFormater = (cell, row) => {
    if (cell) {
      return new moment(cell).format(dateTimeFormat);
    }
  };

  balanceFormttter = (cell) => {
    return `₹ ${parseFloat(cell).toFixed(2)}`;
  };

  editReqHandler = (row) => {
    //console.log(row.id)
    this.setState({
      ReqId: row.id,
      showEditReq: true,
    });
  };

  columns = [
    {
      dataField: "fromMember.uniqueIdentity",
      text: "Username",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
    },
    {
      dataField: "fromMember.company",
      text: "Company",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "fromMember.memberFullName",
      text: "Name",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
    },
    {
      dataField: "creditAmount",
      text: "Credit Amount",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: this.balanceFormttter,
    },

    {
      dataField: "creditDate",
      text: "Credit Date",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: this.dateFormater,
    },
    {
      dataField: "corelationId",
      text: "CorelationId",
      //  formatter: this.dateFormater,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "status",
      text: "Status",
      //  formatter: this.dateFormater,status
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
  ];
  rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };
  NoDataIndication = () => {
    const { loading } = this.state;
    //alert(loading);
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  loadTransaction = async () => {
    const { page, sizePerPage, FromDate, ToDate, Status } = this.state;
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      FromDate,
      ToDate,
      Status,
    });
    if (this.state.dataCount !== 0) {
      this.setState({ loading: true });
    }
    const response = await getAllCreditReports(query);
    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    this.setState({
      loading: false,
      data,
      dataCount: paggingData.TotalCount,
      page: paggingData.CurrentPage,
      sizePerPage: paggingData.PageSize,
    });
  };

  async componentDidMount() {
    await this.loadTransaction();
  }

  refreshFilter = async (e) => {
    this.setState({
      FromDate: "",
      ToDate: "",
      Status: "",
    });
    setTimeout(async () => {
      await this.loadTransaction();
    }, 10);
  };

  handleTableChange = async (type, { page, sizePerPage }) => {
    const currentIndex = (page - 1) * sizePerPage;
    this.setState(() => ({
      page,
      sizePerPage,
      // FromDate,
      // ToDate,
      // Status,
    }));
    setTimeout(async () => {
      await this.loadTransaction();
    }, 10);
  };

  handleSearch = async () => {
    this.setState(() => ({
      page: 1,
      sizePerPage: 10,
    }));

    setTimeout(async () => {
      await this.loadTransaction();
    }, 10);
  };

  handleExport = async () => {
    this.setState(() => ({
      page: 1,
      sizePerPage: 10,
    }));

    setTimeout(async () => {
      await this.exportTransactionLog();
    }, 10);
  };
  exportTransactionLog = async () => {
    const { page, sizePerPage, FromDate, ToDate, Status } = this.state;
    const query = queryStringService.getQueryStringFromObj({
      FromDate,
      ToDate,
      Status,
    });
    if (this.state.dataCount !== 0) {
      this.setState({ loading: true });
    }

    const response = await exportCreditReports(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${moment().toISOString()}_CreditLog.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    this.setState({
      loading: false,
    });
  };
  handleSearchChanges = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    setTimeout(async () => {
      await this.loadTransaction();
    }, 10);
  };

  render() {
    const {
      data,
      sizePerPage,
      page,
      dataCount,
      loading,
      FromDate,
      ToDate,
      Status,
    } = this.state;

    const sizePerPageRenderer = ({
      options,
      currSizePerPage,
      onSizePerPageChange,
      FromDate,
      ToDate,
      Status,
    }) => (
      <>
        <label className="mr-2">Page Size </label>
        <div className="btn-group mr-4" role="group">
          {options.map((option) => {
            const isSelect = currSizePerPage === `${option.page}`;
            return (
              <button
                key={option.text}
                type="button"
                onClick={() => onSizePerPageChange(option.page)}
                className={`btn btn-sm ${
                  isSelect ? "btn-primary" : "btn-secondary"
                }`}
              >
                {option.text}
              </button>
            );
          })}
        </div>
      </>
    );

    const paginationOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      totalSize: dataCount,
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "15",
          value: 15,
        },
        {
          text: "20",
          value: 20,
        },
        {
          text: "50",
          value: 50,
        },
      ],
      sizePerPageRenderer,
    };

    return (
      <>
        <Helmet>
          <title>Credit Opening Closing Report</title>
        </Helmet>
        <Breadcrumb
          routeSegments={[{ name: "Credit Opening Closing Report" }]}
        ></Breadcrumb>

        <div className="card card-body mb-3">
          <div className="row">
            <div className="col-md-4 ">
              <div className="input-group mb-3">
                <input
                  type="date"
                  className="form-control"
                  value={this.state.FromDate}
                  data-date=""
                  data-date-format="YYYY-MM-DD"
                  name="FromDate"
                  onChange={this.handleSearchChanges}
                  max={moment().format("YYYY-MM-DD")}
                />
              </div>
            </div>
            <div className="col-md-4 ">
              <div className="input-group mb-3">
                <input
                  type="date"
                  className="form-control"
                  data-date=""
                  data-date-format="YYYY-MM-DD"
                  value={this.state.ToDate}
                  name="ToDate"
                  onChange={this.handleSearchChanges}
                  max={moment().format("YYYY-MM-DD")}
                />
              </div>
            </div>

            <div className="col d-flex justify-content-around mb-3">
              <button
                className="btn btn-primary  mr-1"
                onClick={this.handleSearch}
              >
                search
              </button>
              {/* </div> */}
              {/* <div className="col-2 d-flex justify-content-around mb-3"> */}
              <button className="btn btn-primary" onClick={this.refreshFilter}>
                Rfresh
              </button>
              <Button
                variant="outline-primary"
                className="ml-1"
                onClick={this.handleExport}
                disabled={!this.state.dataCount}
              >
                Export
                <AiFillFileExcel className=" ml-2" />
              </Button>
            </div>
          </div>
          <BootstrapTable
            hover
            remote
            keyField="uniqueIdentity"
            data={data}
            columns={this.columns}
            pagination={paginationFactory(paginationOptions)}
            onTableChange={this.handleTableChange}
            noDataIndication={() => <this.NoDataIndication />}
            loading={loading}
            overlay={overlayFactory({
              spinner: true,
              styles: {
                overlay: (base) => ({
                  ...base,
                  background: "rgba(120, 120, 120, 0.5)",
                  zIndex: "1",
                }),
              },
            })}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={this.rowStyle}
          />
        </div>
      </>
    );
  }
}
export default CreditOpeningClosing;
